import React from "react";
import { Check } from "lucide-react";
import { cn } from "../../lib/utils";

/**
 * ProcessStepper — the progress bar for the (merged) Process Migration wizard. Steps are dynamic:
 * a "Resolve links" step appears only when the selection turns out to have linked children.
 */
interface ProcessStepperProps {
  steps: string[];
  /** 0-based index of the current step. Steps before it render as done. */
  current: number;
  className?: string;
}

const ProcessStepper: React.FC<ProcessStepperProps> = ({ steps, current, className }) => (
  <div className={cn("flex items-center justify-center", className)}>
    {steps.map((label, i) => {
      const done = i < current;
      const now = i === current;
      return (
        <React.Fragment key={label}>
          {i > 0 && (
            <span
              className={cn(
                "mx-2.5 h-px w-9 shrink-0",
                i <= current ? "bg-primary" : "bg-border"
              )}
            />
          )}
          <div className="flex items-center gap-2">
            <span
              className={cn(
                "flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-xs font-medium transition-colors",
                done && "border-primary bg-primary text-primary-foreground",
                now && "border-primary text-primary",
                !done && !now && "border-border text-muted-foreground"
              )}
            >
              {done ? <Check className="h-3.5 w-3.5" strokeWidth={3} /> : i + 1}
            </span>
            <span
              className={cn(
                "whitespace-nowrap text-xs",
                now ? "font-semibold text-foreground" : done ? "text-foreground" : "text-muted-foreground"
              )}
            >
              {label}
            </span>
          </div>
        </React.Fragment>
      );
    })}
  </div>
);

export default ProcessStepper;
